<!--  -->
<template>
  <div class="barCodeList">
    <el-card>
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span style="font-size: 24px">条码列表</span>
        <div class="head-text" style="float: right; margin-top: -4px">
          <el-select
            filterable
            v-model="types"
            style="margin-right: 20px"
            @change="selectlist"
            placeholder="请选择"
          >
            <el-option label="全部" value="0"></el-option>
            <el-option
              :label="item.tpst03"
              v-for="(item, index) in labelData"
              :key="index"
              :value="item.tpst01"
            ></el-option>
          </el-select>
          <el-button
            v-if="
              ($store.state.permissions != null &&
                $store.state.permissions.includes('1062')) ||
              $store.state.isProject
            "
            type="primary"
            @click="Exports"
            >打印</el-button
          >
          <el-button type="danger" @click="Dangers">删除</el-button>
          <!-- <el-button type="primary" id="exports">打印</el-button> -->
        </div>
      </div>
      <div class="rygl-table">
        <!-- 表格 -->
        <el-table
          align="center"
          class="margin-20 table"
          v-loading="loading"
          :data="userList"
          height="72vh"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          >
          <el-table-column
            align="center"
            type="selection"
            width="55"
          ></el-table-column>
          <el-table-column
            align="center"
            type="index"
            label="序号"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="bacd04"
            label="构件ID号"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="bacd05"
            label="类型名称"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="tpst03"
            label="条码模板"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="user04"
            label="创建用户"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="bacd08"
            label="打印时间"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="bacd09"
            label="打印次数"
          ></el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <!-- <el-button size="small" type="primary" plain @click="examine(scope.row)">查看</el-button> -->
              <el-button
                size="small"
                type="primary"
                plain
                @click="OpenPreview(scope.row)"
                >预览</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          align="center"
          style="margin-top: 20px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagenum"
          :page-sizes="[10, 50, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 预览弹出框 -->
    <el-dialog
      :close-on-click-modal="false"
      title="预览"
      :before-close="PreviewRemove"
      :visible.sync="PreviewShow"
      width="30%"
      center
    >
      <div
        style="
          display: flex;
          justify-content: space-evenly;
          align-items: center;
        "
      >
        <div class="previewDataP">
          <p>构件名称：{{ previewData.bacd05 }}</p>
          <p>构件ID：{{ previewData.bacd04 }}</p>
          <p v-for="(i, index) in previewData.MyProperty" :key="index">
            {{ i.tslk04 }}：{{ i.tslk05 }}
          </p>
        </div>
        <div id="qrcode"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" style="margin-top: 20px" @click="PreviewRemove"
          >取 消</el-button
        >
        <el-button type="primary" @click="PreviewRemove">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 打印PDF -->
    <table id="table2" style="margin-top: 10px; width: 100%; display: none">
      <tbody>
        <el-card>
          <div slot="header">
            <span style="font-size: 12px">打印目标</span>
          </div>
          <div
            v-for="(i, index) in tabeleDatas"
            :key="index"
            style="
              display: inline-block;
              padding: 10px;
              border: 1px solid #c3c3c3;
              border-radius: 4px;
              margin: 5px;
            "
          >
            <div style="display: flex; align-items: center; margin: 20px 0">
              <div>
                <div style="margin-bottom: 10px">构件ID：{{ i.bacd04 }}</div>
                <div style="margin-bottom: 10px">类型名称：{{ i.bacd05 }}</div>
                <div>条码模板：{{ i.tpst03 }}</div>
              </div>
              <div style="margin-left: 20px" :id="'qrcodes' + index + ''"></div>
            </div>
          </div>
        </el-card>
      </tbody>
    </table>
  </div>
</template>

<script>
// api方法
import {
  GetBarCodeList,
  GetBarCodeInfo,
  GetTemplList,
  AddPrintCount,
  DelCodeBars,
} from "@/setAxios.js";
// 打印方法
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  name: "barCodeList",
  components: {},
  data() {
    return {
      deleteIds: [],
      // 打印二维码的数组
      tabeleDatas: [],
      // 预览弹出框
      PreviewShow: false,
      // 预览数据
      previewData: {},
      // 表格选中数组对象
      labelObj: [],
      // 切换条码的数据
      labelData: [],
      // 表格数据
      userList: [],
      // 选择器名称
      types: "全部",
      // 加载效果
      loading: false,
      // 分页数据的数量
      total: 0,
      // 分页页数
      pagenum: 1,
      // 分页显示多少条数据
      pagesize: 10,
    };
  },
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 删除按钮
    Dangers() {
      if (this.deleteIds.length > 0) {
        this.$confirm("确认删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let params = {
            ids: this.deleteIds.join(","),
          };
          DelCodeBars(params).then((res) => {
            this.$message({
              type: res.Code > 0 ? "success" : "warning",
              message: res.Code > 0 ? "删除成功" : res.Message,
            });
            this.getData();
          });
        });
      } else {
        this.$message({
          type: "warning",
          message: "请先选择",
        });
      }
    },
    // 表格打印/可选中单个导出
    Exports() {
      if (this.tabeleDatas.length == 0) {
        this.$message({
          type: "warning",
          message: "没有选中打印目标",
        });
      } else {
        // 获取要打印的目标ID
        let arrays = [];
        this.tabeleDatas.forEach((item) => {
          arrays.push(item.bacd01);
        });
        for (let i = 0; i < arrays.length; i++) {
          // 走api增加打印次数
          let params = {
            id: arrays[i],
          };
          AddPrintCount(params).then((res) => {
            //(res, "打印次数接口");
            this.getData();
          });
        }
        $("#table2").show();
        tableExport("table2", "条码列表", "pdf");
        $("#table2").hide();
      }
      //   // 设置当前日期
      //   let time = new Date();
      //   let year = time.getFullYear();
      //   let month = time.getMonth() + 1;
      //   let day = time.getDate();
      //   let name = year + "-" + month + "-" + day;
      //   const defaultCellStyle = {
      //     font: { name: "Verdana", sz: 11, color: "FF00FF88" },
      //     fill: { fgColor: { rgb: "FFFFAA00" } }
      //   };
      //   const wopts = {
      //     bookType: "xlsx",
      //     bookSST: false,
      //     type: "binary",
      //     defaultCellStyle: defaultCellStyle,
      //     showGridLines: false
      //   };
      //   const wb = { SheetNames: ["Sheet1"], Sheets: {}, Props: {} };
      //   let data = this.labelObj;
      //   wb.Sheets["Sheet1"] = XLSX.utils.json_to_sheet(data);
      //   //创建二进制对象写入转换好的字节流
      //   let tmpDown = new Blob([this.s2ab(XLSX.write(wb, wopts))], {
      //     type: "application/octet-stream"
      //   });
      //   FileSaver.saveAs(tmpDown, name + ".xls");
      // }
    },
    //字符串转字符流
    s2ab(s) {
      if (typeof ArrayBuffer !== "undefined") {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      } else {
        var buf = new Array(s.length);
        for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xff;
        return buf;
      }
    },
    // 获取所有数据
    getData(num) {
      // 开始加载效果
      this.loading = true;
      let params = {
        xid: localStorage.getItem("xid"),
      };
      GetTemplList({ params }).then((res) => {
        this.labelData = res.Data;
      });
      params = {
        xid: localStorage.getItem("xid"),
        type: num || 0,
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
      };
      GetBarCodeList({ params }).then((res) => {
        this.userList = res.Data.list;
        this.total = res.Data.total;
        // 结束加载效果
        this.loading = false;
      });
    },
    // 切换条码
    selectlist(i) {
      //(i);
      this.getData(i);
    },
    // 分页点击切换效果
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
    },
    // 分页点击切换效果
    handleCurrentChange(val) {
      this.pagenum = val;
      this.getData();
    },
    // 表格选中
    handleSelectionChange(i) {
      $("div[id^='qrcodes']").empty();
      this.tabeleDatas = i;
      this.deleteIds = [];
      i.forEach((ele) => {
        this.deleteIds.push(ele.bacd01);
      });
      var qrcodes;
      this.$nextTick(() => {
        for (let k = 0; k < this.tabeleDatas.length; k++) {
          qrcodes = new QRCode("qrcodes" + k, {
            text: "二维码",
            width: 80,
            height: 80,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H,
          });
          qrcodes.makeCode(i[k].bacd10);
        }
      });
      // 深度克隆
      // let obj = JSON.parse(JSON.stringify(i));
      // // 改变打印内容
      // obj.forEach(item => {
      //   item.ID = item.bacd01;
      //   item["构建ID号"] = item.bacd04;
      //   item["类型名称"] = item.bacd05;
      //   item["条码模板"] = item.tpst03;
      //   item["创建用户"] = item.user04;
      //   item["打印次数"] = item.bacd09;
      //   delete item.bacd01;
      //   delete item.bacd02;
      //   delete item.bacd03;
      //   delete item.bacd04;
      //   delete item.bacd05;
      //   delete item.bacd06;
      //   delete item.bacd07;
      //   delete item.bacd08;
      //   delete item.bacd09;
      //   delete item.bacd10;
      //   delete item.bacd11;
      //   delete item.tpst03;
      //   delete item.user04;
      // });
      // this.labelObj = obj;
      // //(this.labelObj);
    },
    // 打开预览
    OpenPreview(row) {
      this.PreviewShow = true;
      let params = {
        bcid: row.bacd01,
      };
      GetBarCodeInfo({ params }).then((res) => {
        //(res, "预览");
        this.previewData = res.Data;
        var qrcode = new QRCode("qrcode", {
          text: "二维码",
          width: 156,
          height: 156,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
        qrcode.makeCode(this.previewData.bacd10);
      });
    },
    // 关闭预览
    PreviewRemove(i) {
      this.PreviewShow = false;
      $("#qrcode").empty();
    },
    // 这里是查看
    examine(row) {
      //(row);
    },
  },
  created() {
    this.getData();
    //(EaBIM, "嘎嘎");
  },
  mounted() {
    // var $exportLink = document.getElementById("exports");
    // $exportLink.addEventListener(
    //   "click",
    //   function(e) {
    //     e.preventDefault();
    //     tableExport("table2", "文件名称", "pdf");
    //   },
    //   false
    // );
  },
};
</script>

<style lang="less" scoped>
.previewDataP p {
  font-size: 14px;
  margin: 0 0 20px;
}
/deep/ .upload-demo ul {
  width: 100%;
  margin-left: 10px;
  margin-bottom: 10px;
}
.user .margin-20 {
  margin: 20px 0;
}
.user .search-input {
  width: 300px;
}
.user .page {
  padding: 5px 0;
  background-color: #d3dce6;
}
.user {
  .btnArr {
    margin-top: 10px;
  }
}

.yq-col:nth-child(1) {
  overflow: hidden;
  margin: 0 0 0 150px;
  span {
    position: relative;
    bottom: 10px;
    left: 10px;
  }
}
.yq-col:nth-child(2) {
  overflow: hidden;
  margin: 0 0 0 0px;
  span {
    position: relative;
    bottom: 10px;
    left: 10px;
  }
}
.yq-col:nth-child(3) {
  overflow: hidden;
  margin: 0 0 0 0px;
  span {
    position: relative;
    bottom: 10px;
    left: 10px;
  }
}
.yq-col:nth-child(4) {
  overflow: hidden;
  margin: 0 0 0 0px;
  span {
    position: relative;
    bottom: 10px;
    left: 10px;
  }
}
.user-loading {
  display: flex;
  margin: 10px 0;
  p {
    margin: 8px 0 0 10px;
    span {
      color: #007acc;
    }
  }
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
/deep/ .el-card__body {
  overflow: hidden;
}
</style>
